/** Read at request time (SSR). Do not use for gating SSG pages. */
export function getInterplayersInSiteActivationEnabled(): boolean {
  return (
    process.env.NEXT_PUBLIC_INTERPLAYERS_IN_SITE_ACTIVATION_ENABLED === 'true'
  );
}

/** Build-time snapshot; prefer `getInterplayersInSiteActivationEnabled()` on the server. */
export const isInterplayersInSiteActivationEnabled =
  getInterplayersInSiteActivationEnabled();
